import { connect } from 'react-redux';
import IntercomChat from 'common/containers/intercom_chat';
import classnames from 'classnames';

const mapStateToProps = ({ pap }, { bodyClasses }) => {
  /* don't display intercom chat if on full screen mode or displaying modal */
  const {
    fullScreen, showingContractPreview, showingEliteConfirmation, showingLogin
  } = pap.workflow;
  const updatedBodyClasses = classnames("intercom-at-pap", {
    "intercom-hide": fullScreen || showingContractPreview || showingEliteConfirmation || showingLogin
  }, bodyClasses);

  return {
    bodyClasses: updatedBodyClasses,
    chatOnly: true
  }
}

export default connect(mapStateToProps)(IntercomChat);



// WEBPACK FOOTER //
// ./pap/containers/intercom_chat.js